import { Entity } from '@/store/shared/entity'
export default class User extends Entity<number>{
    name:string;
    password:string;
    email:string;
    roleIds:number[];
    businessGroup:string;
}